import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "@store/state";
import { Observable } from "rxjs";
import { ActionLogoutUser } from "@store/user";
import { take, tap } from "rxjs/operators";
import { Router } from "@angular/router";

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(public store: Store<AppState>, public router: Router) {}

  /**
   * if status 401 occurs we logout and redirect it into loginpage
   * @param request
   * @param next
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        event => {
          return;
        },
        (err: any) => {
          if (!(err instanceof HttpErrorResponse)) {
            return;
          }
          if (err.status === 401) {
            this.store.dispatch(new ActionLogoutUser());
            this.router.navigate(["login"]);
          }
        }
      )
    );
  }
}
